import { WimFn } from '@/components/service/WimFn'
import { BenModal } from './BenModal'
import { BenQuery } from './BenQuery'
import { BenView } from './BenView'

export class BenGallery {
  static init(dones: any[], app) {
    const $dom = BenQuery.query('[ben-js="gallery"]')
    $dom.forEach(($item) => {
      if (dones.includes($item)) return
      dones.push($item)
      _init($item, app)
    })
  }
}

async function _init($dom: HTMLElement, app) {
  const $itemList = BenQuery.query(':scope .gallery-item', { scope: $dom })
  //插入$cover
  $itemList.forEach(async ($item, index) => {
    const srcListStr = $item.getAttribute('src-list') || ''
    const srcList = srcListStr.split(',')
    $item.addEventListener('click', () => {
      BenView.setAction('iv')
      _showImgs(srcList, app)
    })
    /* await BenQuery.nextTick()
    const $icon = $item.querySelector('.icon')
    if (!$icon) return
    $icon.addEventListener('click', (e) => {
      const target = e.target
      if (target === $icon || !count) return
      _showImgs(tag, count, app)
    }) */
  })
}

async function _showImgs(srcList: string[], app) {
  const $splide = _createSwiperDom(srcList)
  BenModal.init($splide, app, { type: 'image', easyClose: false })
}

function _createSwiperDom(srcList: string[]) {
  let slideHtml = ''
  srcList.forEach((src) => {
    slideHtml += `<div class="swiper-slide"><div class="img"><img src="${src}" /></div></div>`
  })
  const html = `<div class="g009 cd04-modal" ben-js="sw" grid="1" type="normal" between="0" s="black" loop>
        <div class="swiper">
          <div class="swiper-wrapper">
            ${slideHtml}
          </div>
        </div>
      </div>`
  return BenQuery.htmlToElement(html)
}
